import { Component, Input, OnInit } from "@angular/core";
import { QuestionnaireQuestion } from "@models/questionnaire_question";

@Component({
	selector: "restricted-investor-statement",
	templateUrl: "./restricted-investor-statement.component.html",
	styleUrls: ["./restricted-investor-statement.component.scss"],
	standalone: false
})
export class RestrictedInvestorStatementComponent implements OnInit {
	@Input() public question: QuestionnaireQuestion;

	public ngOnInit(): void {
		this.question.getAnswers().forEach((a) => a.setSelected(true));
	}
}
